import { cubicIn } from 'svelte/easing';

export function swipe(
	_node: HTMLElement,
	{
		duration = 200,
		delay = 0,
		axis = 'y',
		reverse = false
	}: { duration?: number; delay?: number; axis?: 'x' | 'y'; reverse?: boolean }
) {
	const style = window.getComputedStyle(_node);
	const matrix = new DOMMatrixReadOnly(style.transform);
	return {
		duration,
		delay,
		css: (t: number) => `
			transform: translate${axis.toUpperCase()}(calc(${(1 - cubicIn(t)) * (reverse ? 1 : -1) * 100}% + ${axis === 'y' ? matrix.m42 : matrix.m41}px));`
	};
}

export function grow(
	_node: HTMLElement,
	{
		duration = 200,
		delay = 0,
		axis = 'y',
		reverse = false
	}: { duration?: number; delay?: number; axis?: 'x' | 'y'; reverse?: boolean }
) {
	const style = window.getComputedStyle(_node);
	const matrix = new DOMMatrixReadOnly(style.transform);

	if (window.innerWidth < 640) {
		return swipe(_node, { duration, delay, axis, reverse });
	}

	return {
		duration,
		delay,
		css: (t: number) => {
			const ct = cubicIn(t);

			const size = ct * (axis === 'y' ? _node.clientHeight : _node.clientWidth);

			const prop = axis === 'y' ? 'height' : 'width';

			const css = `
				${prop}: ${size}px; 
				min-${prop}: ${size}px;
				max-${prop}: ${size}px; 
				flex-basis: ${size}px; 
				overflow: hidden;
			`;

			return css;
		}
	};
}
